import React from "react";
import "./topbar.css";

function Topbar() {
  return (
    <div className="topbar">
      <span>📞+91 98765 43210</span>
      <span>✉️ info@muhurtmedh.com</span>
    </div>
  );
}

export default Topbar;
